import request from '../core/ajax';
// const domain = 'https://goventer-web-ex-pre.vivoglobal.com'; // 预发
// https://goventer-web-ex-test.vivoglobal.com/api/v1/aer/model-list
// https://asia-goventer-web.vivoglobal.com // 线上
export const modelData = (params) => {
    return request.get(`https://asia-goventer-web.vivoglobal.com/api/v1/aer/model-list`, {params});
};
